import { render, staticRenderFns } from "./Assessment.vue?vue&type=template&id=75ec18a6&"
import script from "./Assessment.vue?vue&type=script&lang=ts&"
export * from "./Assessment.vue?vue&type=script&lang=ts&"
import style0 from "./Assessment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports